import React from "react";
import { Box } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import ParticipantsMarquee from "../../components/marquee/ParticipantsMarquee";

/**
 * MagazineParticipantsStrip
 * @param {{ users: any[], isMobile: boolean }} props
 */
const MagazineParticipantsStrip = ({ users, isMobile }) => {
	const theme = useTheme();
	if (!users || users.length === 0) return null;

	const bg = theme.palette.background.default;
	const fadeLeft = `linear-gradient(to right, ${bg} 0%, ${alpha(bg, 0)} 100%)`;
	const fadeRight = `linear-gradient(to left, ${bg} 0%, ${alpha(bg, 0)} 100%)`;
	const fadeWidth = isMobile ? 24 : 40;

	return (
		<Box
			sx={{
				position: "relative",
				overflow: 'hidden',
				width: "100%",
				height: 'auto',
			}}
		>
			<ParticipantsMarquee users={users} isMobile={isMobile} />
			{/* Left gradient fade */}
			<Box
				aria-hidden
				sx={{
					position: "absolute",
					left: 0,
					top: 0,
					bottom: 0,
					width: fadeWidth,
					pointerEvents: "none",
					backgroundImage: fadeLeft,
					zIndex: 1,
				}}
			/>
			{/* Right gradient fade */}
			<Box
				aria-hidden
				sx={{
					position: "absolute",
					right: 0,
					top: 0,
					bottom: 0,
					width: fadeWidth,
					pointerEvents: "none",
					backgroundImage: fadeRight,
					zIndex: 1,
				}}
			/>
		</Box>
	);
};

export default MagazineParticipantsStrip;
